import { FunctionComponent } from "react";
import { cx } from "class-variance-authority";

export interface CountryPickerProps {
  className?: string;
  "data-testid"?: string;
}

/**
 *
 */
export const CountryPicker: FunctionComponent<CountryPickerProps> = ({
  className,
  "data-testid": dataTestId,
  ...props
}) => {
  const css = cx(className);
  const testId = dataTestId || "country-picker";
  return <div className={css} data-testid={testId}></div>;
};
